import { render } from "./ViewFile.vue?vue&type=template&id=1d97ace4&scoped=true&ts=true"
import script from "./viewFileHelper.ts?vue&type=script&lang=ts"
export * from "./viewFileHelper.ts?vue&type=script&lang=ts"

import "./ViewFile.vue?vue&type=style&index=0&id=1d97ace4&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d97ace4"]])

export default __exports__